export class Localizacao {
    localizacaoId: number = 0
    ip: string = ""
    network: string = ""
    version: string = ""
    city: string = ""
    region: string = ""
    region_code: string = ""
    country: string = ""
    country_name: string = ""
    country_code: string = ""
    country_code_iso3: string = ""
    country_capital: string = ""
    country_tld: string = ""
    continent_code: string = ""
    in_eu: boolean = false
    postal: string = ""
    latitude:  number = 0
    longitude:  number = 0
    timezone: string = ""
    utc_offset: string = ""
    country_calling_code: string = ""
    currency: string = ""
    currency_name: string = ""
    languages: string = ""
    country_area:  number = 0
    country_population:  number = 0
    asn: string = ""
    org: string = ""
}
